
type AggregatorClassification = {
    id: number;
    name: string;
    svgwebappId: number;
    order: number;
    status: boolean
    parentId: number | null
    icon: Icon
    type: SectionType
    pluginspaceSegment: SegmentPluginspace
    pluginspaceSegmentId: number
    children: AggregatorClassification[];
    parent: AggregatorClassification;
}



export type Icon = {
    id: number;
    svg: string;
    description: string
    category: string
}

export enum SectionType {
    CATEGORY = "category", // Listagem das Lojas Cadastradas na categoria
    PAGE = "page", // Pagina do conteudo que vincula uma unica loja e demais informaçoes adicionais
    CONTENT = "content",
    SIMPLE = "simple",
    FORM = "form",
}

export const PageOptions = [{
    select: 'Lojas',
    value: SectionType.CATEGORY
}, {
    select: 'Conteúdo',
    value: SectionType.CONTENT
}]

type TableParams = {
    page?: number
    pageSize?: number
    search?: string
    sorting?: { field: string; direction: 'asc' | 'desc' }
}

type CreateAggregatorClassificationDto = {
    name: string
    description: string
    status: boolean
    svgwebappId: number
    order: number
    parentId: number | null
    pluginspaceSegmentId: number
    type: SectionType
}

type UpdateAggregatorClassificationDto = Partial<CreateAggregatorClassificationDto> & { id: number }


export type SegmentPluginspace = {
    "id": number,
    "pluginspaceId": number,
    "segment": string,
    "segmentParent": Segment
}

export type Segment = {
    "id": number,
    "name": string,
    "order": number,
    type: string,
    image: string,

    "active": boolean
}
export type { AggregatorClassification, TableParams, CreateAggregatorClassificationDto, UpdateAggregatorClassificationDto };